import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const HelpCenterCustomizeSidebar = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "help-center-customize-sidebar" */ './hocs')),
});
